import { useEffect, useMemo, useState } from "react";
import { concreteBaseService } from "Dashboard/scenes/ConcreteBase/services/concreteBase.service";
import { IConcreteBaseInputItemUpdate } from "Dashboard/scenes/ConcreteBase/domain/IConcreteBaseInputItemUpdate";
import { IConcreteBaseInputItemCreate } from "Dashboard/scenes/ConcreteBase/domain/IConcreteBaseInputItemCreate";
import { addOwnProductionItem, getOwnProductionItems, selectState, updateConcreteBaseInputItem, updateInputItemTemporarily } from "../outputSlice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import { debounce } from "lodash";
import { toast } from "react-toastify";
import UnitSelect from "Dashboard/components/UnitSelect";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import InfoTooltip from "components/Popup/InfoTooltip";
import NumberInput from "Dashboard/components/NumberInput";
import { numberToStringForInput } from "utils/numberUtils";

const EditableItemInventoryPopover = () => {

  const dispatch = useAppDispatch();

  const { ownProductionItems } = useSelector(selectState);
  const [newItemName, setNewItemName] = useState("");

  useEffect(() => {
    dispatch(getOwnProductionItems());
  }, [dispatch]);

  const onChangeExistingItemField = (data: IConcreteBaseInputItemUpdate) => {
    dispatch(updateInputItemTemporarily(data));
    updateFieldWithDelay(data);
  };

  const onChangeNewItemField = (data: IConcreteBaseInputItemCreate) => {
    addInputItemTemporarily(data);
    createInputItemWithDelay(data);
  };

  const updateFieldWithDelay = useMemo(
    () => debounce(async (data: IConcreteBaseInputItemUpdate) => {
      try {
        await dispatch(updateConcreteBaseInputItem(data)).unwrap();
        toast.success("Izmena je uspešno zabeležena.");
      } catch (status: any) {
        if (status === 400) {
          toast.error("Neočekivana greška");
        }
      }
    }, 1000),
    [dispatch]
  );
  const addInputItemTemporarily = (data: IConcreteBaseInputItemCreate) => {
    setNewItemName(data.itemName);
  };

  const createInputItemWithDelay = useMemo(
    () => debounce(async (data: IConcreteBaseInputItemCreate) => {
      setNewItemName("");
      if (data.itemName !== "") {
        const newItem = await concreteBaseService.createConcreteBaseInputItem(data);
        dispatch(addOwnProductionItem(newItem));
      }
    }, 1000),
    [dispatch]
  );

  return (
    <div className="g-grid g-content concrete-base-item-inventory">
      {ownProductionItems && ownProductionItems.length > 0 ? ownProductionItems.map((item, index) => {
        return <div className="row" key={index}>
          <div className="col">
            <input className="bg-item center strong"
              type="text"
              value={item.latestItemCode || ""}
              onChange={(e) => {
                onChangeExistingItemField({ inputItemId: item.itemId, itemCode: e.target.value })
              }} />
          </div>
          <div className="col">
            <input className="bg-item"
              type="text"
              value={item.name}
              onChange={(e) => {
                onChangeExistingItemField({ inputItemId: item.itemId, itemName: e.target.value })
              }} />
          </div>
          <div className="col">
            <NumberInput
              formatAs="rsd"
              value={numberToStringForInput(item.latestPricePerUnit)}
              onChange={(value: string, unmaskedValue: string, parsedValue: number) => {
                if (parsedValue !== item.latestPricePerUnit) {
                  onChangeExistingItemField({ inputItemId: item.itemId, pricePerUnit: parsedValue });
                }
              }}
              className="bg-item strong"
            />
          </div>
          <div className="col">
            <UnitSelect
              value={item.latestQuantityUnit?.unitId}
              onChange={(newUnit: string) => onChangeExistingItemField({ inputItemId: item.itemId, unit: newUnit })}
              customStyles={styles.rowInMainTableNoBorder}
              isClearable={false}
            />
          </div>
          <div className="col">
            <div className="bg-item"
              onClick={() => onChangeExistingItemField({ inputItemId: item.itemId, canStayInRepository: !item.canStayInRepository })}>
              <InfoTooltip tooltip={item.canStayInRepository ? 'galanterija' : 'beton'} element="span">
                {item.canStayInRepository ? 'g' : 'b'}
              </InfoTooltip>
            </div>
          </div>
        </div>
      })
        : <div className="concrete-base-item-inventory-fallback">Nema unetih sopstvenih proizvoda</div>}
      <div className="row" key={-1}>
        <div className="col">
          <div className="bg-item bg-transparent right">
            <span>novi proizvod:</span>
          </div>
        </div>
        <div className="col">
          <input className="bg-item"
            type="text"
            value={newItemName}
            onChange={(e) => {
              onChangeNewItemField({ itemName: e.target.value, isOwnProduct: true })
            }} />
        </div>
        <div className="col">
          <div className="bg-item bg-transparent">
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditableItemInventoryPopover;
